import { useNavigate, useLocation } from "react-router-dom";

export default function MiniNavigationTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const tabs = [
    { label: "Player List", path: "/pt-logs-player-list" },
    { label: "Pending Review", path: "/pending-review-pt-log" },
    { label: "Guidelines", path: "/manage-guidelines" },
  ];

  return (
    <div className="flex justify-center mt-2 mb-4 border-b">
      {tabs.map((t) => {
        const active = pathname.startsWith(t.path);
        return (
          <button
            key={t.path}
            onClick={() => navigate(t.path)}
            className={`
              px-3 py-1 border text-sm
              ${active ? "bg-blue-600 text-white font-semibold" : "bg-white-200 text-gray-700"}
            `}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
